// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".group_item .el-row[data-v-a1f99814]{border-bottom:1px solid #888}.group_item .el-row[data-v-a1f99814]:last-child{border-bottom:none}", ""]);
// Exports
module.exports = exports;
